<div class="help-centre">
  <button mat-icon-button [matMenuTriggerFor]="helpMenu">
    <mat-icon svgIcon="help"></mat-icon>
  </button>

  <mat-menu #helpMenu="matMenu" class="help-centre__menu" backdropClass="help-custom_backdrop">
    <div
      class="help-centre__content--header flex__justify-between flex__align-center padding-vertical--half padding-horizontal--one"
    >
      <span><h5>Help centre</h5></span>
      <button mat-icon-button mat-menu-close>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>

    @for (item of links; track item) {
      <a [href]="item.url" target="_blank" class="help-centre__item" mat-menu-item>
        <mat-icon class="help-centre__item-icon" svgIcon="{{ item.icon }}"></mat-icon>
        <div class="help-centre__item-text">
          <div class="help-centre__item-title">
            <h6>{{ item.title }}</h6>
          </div>
          <div class="help-centre__item-description">{{ item.description }}</div>
        </div>
      </a>
    }
  </mat-menu>
</div>
